exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".personal__title {\n  margin: 0;\n  height: 70px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8; }\n\n.personal__content {\n  padding: 20px 30px; }\n\n.personal__label {\n  color: #999;\n  margin-bottom: 5px; }\n\n.personal__field {\n  margin-bottom: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/PERSONAL_INFO_PAGE/components/PersonalArea/index.scss
// module id = 458
// module chunks = 0